import { render, staticRenderFns } from "./editRentShop.vue?vue&type=template&id=b79f2264&"
import script from "./editRentShop.vue?vue&type=script&lang=js&"
export * from "./editRentShop.vue?vue&type=script&lang=js&"
import style0 from "./editRentShop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports